import React, { useState } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import animateBannerIcon from "../../images/animateBannerIcon.svg";
const LayersWindow = (props) => {

  return (
    <>
      <div className="layersWindow" >
       <div className="layers-window-text" >
        <div>
        <img src={animateBannerIcon} className="animateBannerIcon"/>
        <h6 className="useTimelineText p-2 pt-2">Use the timeline below to animate your banner as needed</h6>
        </div>
        </div>
      </div>
    </>
  );
};

export default LayersWindow;
